import React from "react";
import { Text, Button, TextInput } from "react-native-paper";
import { TextField } from "./TextField";
import { PhoneField } from "./PhoneField";
import { TextAreaField } from "./TextAreaField";
import { NumberField } from "./NumberField";
import { StatusField } from "./StatusField";
import { DropdownField } from "./DropdownField";
import { CollectionPickerField } from "./CollectionPickerField";
import { DateField } from "./DateField";
import { CheckboxField } from "./CheckboxField";
import { PaymentsField } from "./PaymentsField";
import FileField from "./FileField";
import { CalculateItemsField } from "./CalculateItemsField";
import { WarehouseItemsField } from "./WarehouseItemsField";
import { Calculation } from "../Calculation";
import { MechanicPicker } from "../MechanicPicker";
import SegmentedButtonsField from "../SegmentedButtonsField";
import { ChecklistField } from "./ChecklistField";
import { ChatField } from "./ChatField";
import { FormFieldProps } from "../FormFieldProps";
import { View } from "react-native";

export type FieldComponentProps = Omit<FormFieldProps, "index"> & {
  config?: any;
  id?: string;
};

type FieldComponent = React.ComponentType<any>;

export const fieldRegistry: Record<string, FieldComponent> = {
  text: TextField,
  email: TextField,
  url: TextField,
  password: TextField,
  phone: PhoneField,
  textarea: TextAreaField,
  number: NumberField,
  status: StatusField,
  dropdown: DropdownField,
  collectionPicker: CollectionPickerField,
  dateTime: DateField,
  dateTimeNoYear: DateField,
  datePicker: DateField,
  file: FileField,
  fileAndDocument: FileField,
  document: FileField,
  booleanCheckbox: CheckboxField,
  checklist: ChecklistField,
  paymentsForm: PaymentsField,
  testPicker: CalculateItemsField,
  warehouseItemsPicker: WarehouseItemsField,
  mechanicPicker: MechanicPicker,
  calculated: Calculation,
  segmentedButtons: SegmentedButtonsField,
  chat: ChatField,
};

// Fallback components for unimplemented field types
export const UnimplementedField = ({ field }: { field: any }) => (
  <View>
    <Text>{field.label}</Text>
    <Text>This field type is not yet implemented</Text>
  </View>
);

export const ReferenceField = ({ field, value, onChange }: any) => (
  <TextInput
    testID={"email-client"}
    label={field.label}
    value={value}
    onChangeText={(text) => onChange(field.name, text)}
  />
);

export const RatingField = ({ field }: any) => (
  <View>
    <Text>{field.label}</Text>
    <Text>Rating component goes here</Text>
  </View>
);

export const ColorField = ({ field }: any) => (
  <View>
    <Text>{field.label}</Text>
    <Text>Color picker component goes here</Text>
  </View>
);

export const OtpField = ({ field, value, onChange }: any) => (
  <TextInput
    label={field.label}
    value={value}
    onChangeText={(text) => onChange(field.name, text)}
    keyboardType="number-pad"
  />
);

export const SignatureField = ({ field }: any) => (
  <Button
    mode="contained"
    onPress={() => console.log("Open signature capture")}
  >
    {field.label}
  </Button>
);

// Register fallback fields
fieldRegistry.reference = ReferenceField;
fieldRegistry.rating = RatingField;
fieldRegistry.color = ColorField;
fieldRegistry.otp = OtpField;
fieldRegistry.signature = SignatureField;

export const getFieldComponent = (fieldType: string): FieldComponent => {
  return fieldRegistry[fieldType] || UnimplementedField;
};
